import { keyframes } from "styled-components"

// KEYFRAMES
export const moveUp = keyframes`
    0% {
        transform: translate(0, 20px);
    }
    100% {
        transform: translate(0px);
    }
`
